import pl from "@locales/clinic_general/pl.json";
import en from "@locales/clinic_general/en.json";

export default {
  pl: pl,
  en: en,
};
